import { render } from "./Lock.vue?vue&type=template&id=9abca4f2&scoped=true"
import script from "./Lock.vue?vue&type=script&lang=js"
export * from "./Lock.vue?vue&type=script&lang=js"

import "./Lock.vue?vue&type=style&index=0&id=9abca4f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9abca4f2"

export default script